var render = function render(){var _vm=this,_c=_vm._self._c;return _c('price-description',{attrs:{"price_descriptions":_vm.price_description}})
}
var staticRenderFns = []

export { render, staticRenderFns }